import { CnpForm, DocumentType, StatementStatus } from "../../types";
import { BaseStatement, Product } from "./types";

const getBaseStatement = (id: string, createDate: string, statementForm: CnpForm, status?: StatementStatus): BaseStatement => {
  const { customerInformation } = statementForm;
  const { billingAddress } = customerInformation;
  const { paymentTerms } = statementForm;
  const { lineItems } = statementForm;
  const baseStatement: BaseStatement = {} as BaseStatement;
  baseStatement.id = id;
  baseStatement.createDate = createDate;
  baseStatement.customer = {
    customerName: customerInformation.customerName,
    contactNumber: customerInformation.contactNumber,
    emailAddress: customerInformation.emailAddress,
    billingAddress: {
      country: billingAddress.country,
      city: billingAddress.city,
      complexBuilding: billingAddress.complexBuilding,
      postalCode: billingAddress.postalCode,
      province: billingAddress.province,
      streetAddress: billingAddress.streetAddress,
      suburb: billingAddress.suburb,
    },
  };
  baseStatement.dueDate = paymentTerms.dueDate;
  baseStatement.invoiceReference = paymentTerms.invoiceNumber;
  baseStatement.additionalNotes = paymentTerms.additionalNotes;
  baseStatement.documentType = DocumentType.INVOICE;
  baseStatement.status = status || StatementStatus.DRAFT;
  baseStatement.productList = lineItems.map((item) => {
    return {
      name: item.itemName,
      description: item.description,
      quantity: parseInt(item.lineItemQuantity, 10),
      price: parseInt(String(parseFloat(item.price) * 100), 10),
      vat: item.vatIncluded,
    } as Product;
  });
  return baseStatement;
};

export default getBaseStatement;
